import throttle from 'lodash-es/throttle';

import cssClasses from '../helpers/cssClasses';
import {on} from '../helpers/utils';

// DOM Selectors
const selectors = {
  backToTop: '[js-back-to-top]',
  container: '[data-add-to-cart]',
};

export default () => {
  // Node Selectors
  const nodeSelectors = {
    backToTop: document.querySelector(selectors.backToTop),
    container: document.querySelector(selectors.container),
  };

  // Set listeners
  function setListeners() {
    on('click', nodeSelectors.backToTop, (event) => handleBackToTop(event));
    on('scroll', throttle(showBackToTop, 100));
  }

  // Open + Close Toggles
  function handleBackToTop(event) {
    event.preventDefault();

    // const y =
    //   nodeSelectors.container.offsetTop -
    //   window.innerHeight +
    //   nodeSelectors.container.clientHeight;

    const elem = nodeSelectors.container;
    const yOffset = -200;
    const y = elem.getBoundingClientRect().top + window.pageYOffset + yOffset;

    // eslint-disable-next-line babel/no-unused-expressions
    window.scrollTo({
      top: y,
      left: 0,
      behavior: 'smooth',
    }),
      

    // Alternate scroll method (doesn't work on tablets/mobile because of the fixed header)
    nodeSelectors.container.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }

  function showBackToTop() {
    if (isScrolledIntoView()) {
      nodeSelectors.backToTop.classList.remove(cssClasses.active);
      return;
    }

    nodeSelectors.backToTop.classList.add(cssClasses.active);
  }

  function isScrolledIntoView() {
    const rect = nodeSelectors.container.getBoundingClientRect();
    const elemTop = rect.top;
    const isVisible = elemTop >= 0;
    return isVisible;
  }

  function init() {
    setListeners();

    // console.log(nodeSelectors.container.offsetTop);
    // console.log(window.innerHeight);
    // console.log(nodeSelectors.container.clientHeight);
  }

  // Public interface
  return Object.freeze({
    init,
  });
};
